module.exports = __webpack_public_path__ + "static/media/smallsm1.07efc08e.png";